/**
 * Em que ambiente a tela está (25/09). Com dois ambientes no ar — o da cliente e o de
 * homologação —, testar no errado é questão de uma aba. Fora de produção a topbar diz qual é.
 *
 * Lido uma vez, de `/saude/vivo`, que não exige sessão. Sem resposta, não mostra nada: um
 * selo errado seria pior que nenhum.
 */
import { useEffect, useState } from "react";

const ROTULOS: Record<string, string> = {
  homolog: "Homologação",
  local: "Desenvolvimento",
};

export function rotuloDoAmbiente(
  ambiente: string | null | undefined,
): string | null {
  return ambiente ? (ROTULOS[ambiente] ?? null) : null;
}

export function useAmbiente(): string | null {
  const [rotulo, definirRotulo] = useState<string | null>(null);
  useEffect(() => {
    let vivo = true;
    fetch("/saude/vivo")
      .then((r) => r.json() as Promise<{ ambiente?: string }>)
      .then((corpo) => vivo && definirRotulo(rotuloDoAmbiente(corpo.ambiente)))
      .catch(() => undefined);
    return () => {
      vivo = false;
    };
  }, []);
  return rotulo;
}
